<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><span class="m-bold">Table of Contents</span></h2>
<p class="toc-fm"><a href="#/xhtml/fm02">Acknowledgements</a></p>
<p class="toc-chap"><a href="#/xhtml/fm03"><span class="tno">Preface</span> The Case for Consumer Centricity in Healthcare</a></p>
<p class="toc-chap"><span href="#/xhtml/fm04" title="Link target outside of Sample"><span class="tno">Introduction</span> Making the Healthcare Shift</span></p>
<p class="toc-chapt"><span href="#/xhtml/chap01" title="Link target outside of Sample"><span class="tno">The First Shift</span> From Tactical Fixes to a Holistic Experience Strategy</span></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="tno">The Second Shift</span> From Fragmented Care to Connected Ecosystems</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">The Third Shift</span> From Population-Centric To Person-Centered</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">The Fourth Shift</span> From Incremental Improvements To Pervasive Innovation</span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">The Fifth Shift</span> From Insights as a Department to a Culture of Consumer Obsession</span></p>
<p class="toc-fm"><span href="#/xhtml/bm01" title="Link target outside of Sample">Creating a Consumer-Centric Culture</span></p>
<p class="toc-fm"><span href="#/xhtml/bm02" title="Link target outside of Sample">Leveraging Digital to Transform</span></p>
<p class="toc-chap"><span href="#/xhtml/bm03" title="Link target outside of Sample"><span class="tno">Conclusion</span> The Path to Transformation</span></p>
<p class="toc-fm"><span href="#/xhtml/bm04" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc-fm"><span href="#/xhtml/bm05" title="Link target outside of Sample">Appendix</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?05b7eb32